import React, { Fragment, useEffect } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { A } from 'wanderu-component-react-router-link';
import { Typography } from 'wanderu-components';

import events from './events';

import styles from './CarrierPolicies.scss';

const policyTextMap = {
    baggage: 'Baggage Allowance',
    cancellation: 'Changes & Cancellations',
    disabilities: 'Passengers with Disabilities',
    pets: 'Traveling with Animals',
};

export const CarrierPolicies = (props) => {
    const {
        carrierCodes,
        carrierPolicies,
        className,
        fetchPolicy,
        isOneWay,
        itineraryId,
        price,
        tripIds,
    } = props;

    useEffect(() => {
        carrierCodes.map(code => fetchPolicy(code));
    }, [carrierCodes, fetchPolicy]);

    if (!carrierPolicies?.[0]) {
        return null;
    }

    const onClick = ({ code, type }) => {
        events.clickPolicyEvent({
            carrier_code: code,
            is_one_way: isOneWay,
            itinerary_id: itineraryId,
            link_type: type,
            price,
            trip_ids: tripIds,
        });
    };

    return (
        <div className={classNames(styles.container, className)}>
            <Typography variant="h5">Carrier Quick Links</Typography>
            {carrierPolicies.map(policy => {
                const entries = policy?.policies && Object.entries(policy?.policies);

                if (!policy || !entries?.length) {
                    return undefined;
                }

                const {
                    code,
                    name,
                } = policy;

                return (
                    <Fragment key={name}>
                        <Typography className={styles.carrierName}>{name}</Typography>
                        <ul className={styles.list}>
                            {entries.map(([type, value]) => (<li key={name + type}>
                                <A href={value} onClick={() => onClick({ code, type })} rel="nofollow noopener noreferrer" target="_blank">{policyTextMap[type]}</A>
                            </li>))}
                        </ul>
                    </Fragment>
                );
            })}
        </div>
    );
};

CarrierPolicies.propTypes = {
    carrierCodes: PropTypes.arrayOf(PropTypes.string),
    carrierPolicies: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
        contact: PropTypes.shape({
            phone: PropTypes.arrayOf(PropTypes.string),
            url: PropTypes.string,
        }),
        name: PropTypes.string.isRequired,
        policies: PropTypes.shape({
            baggage: PropTypes.string,
            cancellation: PropTypes.string,
            disabilities: PropTypes.string,
            pet: PropTypes.string,
        }),
    })),
    className: PropTypes.string,
    fetchPolicy: PropTypes.func,
    isOneWay: PropTypes.bool,
    itineraryId: PropTypes.string,
    price: PropTypes.string,
    tripIds: PropTypes.arrayOf(PropTypes.string),
};
